import { createContext, useEffect, useState } from "react";
import useErrorReporting from "../errorReporting/errorReportingService";
import ReportingErrorBoundary from "../errorReporting/ReportingErrorBoundary";
import useTelemetry from "../telemetry/telemetryService";
import { API_PATH } from "../constants";

export const AppConfigContext = createContext(null);

const AppConfiguration = ({ children }) => {
  const [configured, setConfigured] = useState(false);
  const [config, setConfig] = useState({});
  const { start: startErrorReporting } = useErrorReporting();
  const { start: startTelemetry } = useTelemetry();

  useEffect(() => {
    async function loadConfiguration() {
      // Using fetch rather than axios to avoid circular dependency issues.
      // This call is anonymous so we don't require authentication.
      const response = await fetch(`${API_PATH.replace(/\/$/, '')}/appconfiguration`).then(res => res.json());
      if (response.errorReportingKey) startErrorReporting(response.errorReportingKey);
      if (response.telemetryKey) startTelemetry(response.telemetryKey);
      setConfig(response);
      setConfigured(true);
    }
    loadConfiguration();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return configured ? (
    <AppConfigContext.Provider value={config}>
      <ReportingErrorBoundary>
        {children}
      </ReportingErrorBoundary>
    </AppConfigContext.Provider>
  ) : null;
};

export default AppConfiguration;
